import { createFileRoute } from '@tanstack/react-router'
import { ContactPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/kontakt')({
  head: () => staticRouteHead('contact', 'de'),
  component: ContactPage,
})
